import { HiPencilAlt, HiTrash } from 'react-icons/hi';
import HeaderTable from 'components/table/headerTable';
import { BUTTON_COLOR, exportFileName} from 'utils/constants';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { initCategory } from 'utils/initData';
import { useTranslation } from 'react-i18next';
import { categoryTypes } from 'utils/proptypes';
import SpinnerComponent from 'components/spinner';
import { isEqual } from 'lodash';
import ButtonIconWithText from '../../../components/button/buttonIconWithText';
import { getPlans } from '../../../api/subscriptionApi';
import CategoryModal from 'components/modal/categoryModal';
import { toast } from 'react-toastify';
import { messageErrors } from 'utils/utils';
import {  deleteCourseCategories,getCourseCategories,  } from 'api/courseCatetoriesApi';
// import {  HiRefresh, HiX,  } from 'react-icons/hi';

import * as XLSX from 'xlsx';
//Delete modal
import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react' 
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
 
const Categorie = () => {
  const [t] = useTranslation();
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [categories, setCategories] = useState([]);
  const [targetCategory, setTargetCategory] = useState(initCategory);
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [deleteId, setDeleteId] = useState();
  const [show, setShow] = useState(false);
 
const cancelButtonRef = useRef(null)
const handleClickDelete =(id:any)=>{
  setDeleteId(id)
  setShow(true)}
const handleClose=()=>{
  setShow(false)
}
  const handleDeleteItem=async()=>{
    // const newArray = categories.filter((item: categoryTypes)=>item.id !==deleteId);
    //
    // setCategories(newArray);

    await deleteCourseCategories(deleteId)
      const resetData = categories.filter((c: categoryTypes) => deleteId !== c.id);
      setCategories(resetData)
      const message: string = t('categoryPage.createDeleteMessage');
      toast.error(message);


    setShow(false)
  }
  // const handleClickAddCategorie = () => {
  //   setTargetCategory(initCategory);
  //   setOpenModal(true);
  //   setIsEdit(false);
  // };
  const handleClickAddCategorie = () => {
    setTargetCategory(initCategory);
    setOpenModal(true);
    setIsEdit(false);
  };

    const getCategories = useMutation('getCourseCategories', {
    mutationFn: getCourseCategories,
    onSuccess: ({ data }) => {
      setCategories(data.entities);
    },
    onError: error => {
      setCategories([]);
      const message: string = messageErrors(error, t);
      toast.error(message);
    },
  });

  const fetchData = () => {
    getCategories.mutate();
  };

  const handleSearch = () => {
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
    // console.log(categories)
    // eslint-disable-next-line
  }, [currentPage]);

  const handleClickEdit = (item: categoryTypes) => {
    setTargetCategory(item);
    setIsEdit(true);
    setOpenModal(true);
  };
  // const fetchUsers = () => {
  //   getUsers.mutate({ page: currentPage, limit: pageCount, searchQuery: searchValue });
  // };
 
  // const handleClickDelete = async (item: categoryTypes) => {
  //   await deleteCourseCategories(item.id)
  //   const resetData = categories.filter((c: categoryTypes) => item.id !== c.id);
  //   setCategories(resetData)
  //   const message: string = t('categoryPage.createDeleteMessage');
  //   toast.error(message);
  // }
  // const fetchData = () => {
  //   getCategories.mutate({ page: currentPage, limit: pageCount, searchQuery: searchValue });
  // };
  // const handleActiveCategorie = async (item: categoryTypes) => {
  //   const response = await updateActiveCategorieById(item.id, { isActive: !item.isActive });
  //   response.status === apiStatus.SUCCESS && fetchData();
  // };

  const { refetch: fetchPlans } = useQuery('getPlans', () => getPlans(), {
    enabled: false,
    onSuccess: ({ data }) => {
      if (Array.isArray(data.entities)) {
        // const options = data.entities.map((item: any) => {
        //   return { value: item.id, label: item.name, interval: item.interval, duration: item.duration };
        // });
      }
    },
  });



  useEffect(() => {
    fetchPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportCategorieHandler = () => {
    const name = exportFileName.USER;
    if (categories[0] !== initCategory && categories.length > 0) {
      const exportedData = categories.map((categories: categoryTypes) => {
        return {
          ' name': categories.name,
          
        };
      });
      const wb = XLSX.utils.json_to_sheet(exportedData);
      const wbout = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wbout, wb, 'test');
      XLSX.writeFile(wbout, name);
    }
  };

  
  return (
    <div className="w-full">
      <Transition.Root show={show} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed z-10 inset-0 overflow-y-auto"
                    initialFocus={cancelButtonRef}
                    onClose={handleClose}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed justify-center pt-5 inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="hidden sm:inline-block sm:align-middle sm:h-screen "
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <div className="inline-block a  align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                                <div className="sm:flex sm:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <ExclamationCircleIcon
                                            className="h-6 w-6 text-red-600"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg leading-6 font-medium text-gray-900"
                                        >
                                            {t('categoryPage.ModalHeaderDeleteInstitution')}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                            {t('categoryPage.createMessageContentModalDelete')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
                                    
                                     
                                    <ButtonIconWithText
                        text={t('categoryPage.ModaalBTNDeleteD')}
                        onClick={() =>handleDeleteItem()}
                        Icon={HiTrash}
                        color={BUTTON_COLOR.RED}
                       />
                                    <button
                                        type="button"
                                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={handleClose}
                                        ref={cancelButtonRef}
                                    >
                                       {t('categoryPage.ModaalBTNDelete')}
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>
      <HeaderTable
        placeholderSearch="Search for users"
        buttonName="Add Category"
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        handleAddClick={handleClickAddCategorie}
        handleOnClickExport={exportCategorieHandler}
        fetchData={handleSearch}
      />

      {!isEqual(categories[0], initCategory) && categories.length > 0 && (
        <div className="overflow-x-auto relative">
          <table className="w-full text-sm text-left dark:text-gray-400">
            <thead className="text-sm text-gray-600 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-4">
                  {t('admin.courses.category')}
                </th>
                <th scope="col" className="py-3 w-6" />
                <th scope="col" className="py-3 w-6" />
              </tr>
            </thead>
            <tbody>
              {categories?.map((item: any, key) => {
                
                return (
                  <tr
                    key={`${key}-list-user`}
                    className="font-medium text-gray-900 bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600"
                  >
                    <td className="hidden-mobile-tablet py-3 px-4">{item?.name}</td>
                    <td className="py-3 flex">
                      <ButtonIconWithText
                        text={t('userManagementPage.edit')}
                        onClick={() => handleClickEdit(item)}
                        className="edit-btn cursor-pointer p-0.5 text-white bg-blue-600
                      border-gray-300 hover:bg-blue-700 focus:ring-4
                      focus:ring-blue-300 focus:!ring-2 group flex h-min
                      w-fit items-center justify-center text-center
                      font-medium focus:z-10 rounded-lg mr-2"
                        Icon={HiPencilAlt}
                        color={BUTTON_COLOR.BLUE}
                      />
                      <ButtonIconWithText
                        text={t('categoryPage.Delete')}
                        onClick={() => handleClickDelete(item.id)}
                        Icon={HiTrash}
                        color={BUTTON_COLOR.RED}
                      />
                      {/* <ButtonIconWithText
                        text={item.isActive ? <span>{t('userManagementPage.deactivate')}</span> : <span>{t('userManagementPage.reactivate')}</span>}
                        onClick={() => handleActiveCategorie(item)}
                        Icon={item.isActive ? HiX : HiRefresh}
                        color={item.isActive ? BUTTON_COLOR.RED : BUTTON_COLOR.GRAY}
                      /> */}
                 
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {getCategories.isLoading && <SpinnerComponent />}
        </div>
      )}
      <CategoryModal
        headerTitle={isEdit ? t('categoryPage.editCategory') : t('categoryPage.addCategory')}
        openModal={openModal}
        isEdit = {isEdit}
        setOpenModal={setOpenModal}
        targetData={targetCategory}
        successFunc={fetchData}
      />
      
    </div>
  );
};
export default Categorie;